import { SelectItem } from 'api/types';
import { DefaultState } from 'features/types';
import { JobSeekerCommunityAdminRole } from 'features/job-seeker-auth';

export type JobSeekerManageState = DefaultState & {
  manageFormData: JobSeekerManageFormData | null;
};

export interface JobSeekerQuestionnaireAnswer {
  programId: string;
  programName: string;
  answers: {
    questionText: string;
    answerText: string;
  }[];
}

export type JobSeekerManageFormData = {
  programs: SelectItem[];
  isVerified: boolean;
  communityAdminRole: JobSeekerCommunityAdminRole;
  leadPrograms: SelectItem[];
  managers: {
    program: SelectItem;
    managerUsers: SelectItem[];
  }[];
  questionnaires?: JobSeekerQuestionnaireAnswer[];
  organizationAllProgramIds?: string[];
  memberCommunityAdminRolesSelectList?: SelectItem[];
  memberProgramRolesSelectList?: SelectItem[];
  canRemove?: boolean;
};

export type JobSeekerManagersForm = {
  programId: string;
  managerUsersIds?: string[];
  managerUsers?: SelectItem[];
}

export type JobSeekerManageForm = {
  isVerified: boolean;
  programsIds: string[];
  programs: SelectItem[];
  communityAdminRole?: JobSeekerCommunityAdminRole;
  leadProgramsIds: string[];
  programRoles: MemberProgramRolesSelect;
  managers: JobSeekerManagersForm[];
  questionnaires?: JobSeekerQuestionnaireAnswer[];
};

export enum MemberProgramRoles {
  Member = 'Member',
  ProgramLead = 'ProgramLead',
}

export interface ProgramRole {
  value: string;
  text: string;
  role: MemberProgramRoles;
}

export type MemberProgramRolesSelect = Record<string, ProgramRole[]>;
